import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import Main from './ui/layouts/Main';
import Signup from './ui/pages/Signup';
import Signin from './ui/pages/Signin';
import ForgotPassword from './ui/pages/ForgotPassword';
import Home from './ui/pages/home/Home';

import Forums from './ui/pages/forums/Forums';
import ForumsSubOrTopics from './ui/pages/forums/ForumsSubOrTopics';
import ForumsTopic from './ui/pages/forums/ForumsTopic';
import TopUsers from './ui/pages/forums/TopUsers';
// import Messenger from './ui/pages/Messenger.jsx';
import {harmonyCatToFacette} from './libs/helper';
import Messenger from './ui/pages/messenger/Messenger';
import MediaViewer from './ui/pages/MediaViewer';
import MediaViewerPage from './ui/pages/MediaViewer';

import Articles from './ui/pages/Articles';
import FilActu from './ui/pages/fil-actu/FilActu';
import Stories from './ui/pages/Stories';
import Notifications from './ui/components/notifications/Notifications';
import Settings from './ui/pages/settings/Settings';
import Meet from './ui/pages/Meet/Meet';
import Search from './ui/pages/search/Search';
import Moderation from './ui/pages/comments-moderation/Moderation';

import ProfileUser from './ui/pages/profile/ProfileUser';

import RequireAuth from './ui/hoc/Authentication';

import Charter from './ui/pages/charter/Charter';
import Terms from './ui/pages/Terms';
import HistoryPage from './ui/pages/History';
import Contact from './ui/pages/contact/Contact';
//import DeleteAccount from './ui/pages/DeleteAccount';

import ErrorNotFound from './ui/pages/ErrorNotFound';
import PrivacyPolicy from "./ui/pages/PrivacyPolicy";
import SignupStep from "./ui/pages/SignupStep";
import Photo from "./ui/pages/Photo";
import Video from "./ui/pages/Video";
import Echo from "./ui/pages/Echo";
import {StoryTerms} from "./ui/pages/StoryTerms";
import tagSearch from './ui/pages/tagSearch';
import PcReporting from "./ui/pages/pc-reporting";
import ConfirmEmail from "./ui/pages/ConfirmEmail";
import ResetPasswordPage from "./ui/pages/ResetPassword";
import ConfirmAccount from "./ui/pages/ConfirmAccount";

import FacettesUri from "./ui/pages/facettes/IndexFacetteUri";

import Profile from "./ui/pages/profile/Profile";

import ROUTES_CONFIG from './routesConfig';
import FacettesAncre from "./ui/pages/facettes/IndexFacetteAncre";
import ConfirmSuppressionAccount from "./ui/pages/ConfirmSuppressionAccount";
import ChatWebcam from "./ui/pages/ChatWebcam";
//import Webcam from "./ui/pages/Webcam";
import createLink from "./libs/createLink";
import _ from "lodash";
import ForumLastTopics from "./ui/pages/forums/ForumLastTopics";
import ComparatorDating from "./ui/pages/ComparatorDating";
import TagModerations from "./ui/pages/tagModerations/TagModerations";
import ChatWebcamBanned from "./ui/pages/chatWebcamBanned";
import ChangeWeakPassword from "./ui/pages/ChangeWeakPassword";
import ComparatorWebcam from "./ui/pages/compatatorWebcam/CompatatorWebcam";
import NextEditorTest from "./ui/pages/NextEditorTest";
import ParentalControl from "./ui/pages/ParentalControl/ParentalControl";
import TrustSecurity from "./ui/pages/trustSecurity/TrustSecurity";


// import Subscription from "./ui/components/ModalSubscription";


function RedirectWithStatus({from, to, status = 301, location, isPagination = false, isParams = false}) {
    if (location.pathname && from.match(/:params\(\[A-Za-z0-9_-]\+\)/)) {
        from = from.replace('/:params([A-Za-z0-9_-]+)', '');
        to = location.pathname.replace(from, to);
    }
    return (
        <Route
            render={({staticContext}) => {
                // there is no `staticContext` on the client, so
                // we need to guard against that here
                if (staticContext) staticContext.status = status;
                return <Redirect from={from} to={to} state={{ status: status }}/>;
            }}
        />
    );
}

function RedirectVideoCategories({location, computedMatch}) {
    let currentCategory = `/${_.get(computedMatch,"params.tagSlug") || ""}`;
    if(currentCategory && currentCategory !== "" && !currentCategory.endsWith("/")){
        currentCategory = `${currentCategory}/`;
    }
    let categories = harmonyCatToFacette();

    let to = categories[currentCategory] ? createLink('facette', {slug : categories[currentCategory]}) : "/404";
    return <Redirect from="/videos/:tagSlug([A-Za-z0-9_-]+)" to={to} state={{ status: 301 }}/>
}

function interceptFacetteUri({location, match}) {
    let currentUrl = location.pathname;
    currentUrl = currentUrl.replace(createLink('facette'), '');
    let page = currentUrl.split('/').pop();
    if(!isNaN(parseFloat(page)) && isFinite(page)){
        currentUrl = currentUrl.replace(`/${page}`, '');
    }
    return <Route path={`/f/:categorySlug(${currentUrl})/:page([0-9]+)?`} component={FacettesUri} />
}

function MainRouter() {
    return (
        <Switch>
            <Route exact path="/echo" component={Echo}/>
            <Route exact path="/chat-webcams/banned" component={RequireAuth(ChatWebcamBanned)}/>
            <Main>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/test-editor" component={NextEditorTest}/>
                    <Route path="/inscription" component={Signup}/>
                    <Route path="/first-connexion" component={SignupStep}/>
                    <Route path="/connexion" component={Signin}/>
                    {/*<Route path="/subscription" component={RequireAuth(Subscription)}/>*/}
                    <Route path="/forgot-password" component={ForgotPassword}/>
                    <Route path="/change-password" component={ChangeWeakPassword}/>
                    <Route exact path="/webcams" component={ComparatorWebcam}/>
                    <Route exact path="/comparateur/rencontres" component={ComparatorDating}/>


                    <Route exact path="/chat-webcams" component={RequireAuth(ChatWebcam)}/>

                    <Route path="/email-verification" component={ConfirmEmail}/>
                    <Route path="/verification-compte" component={ConfirmAccount}/>
                    <Route path="/nouveau-mot-de-passe" component={ResetPasswordPage}/>
                    <Route path="/user/:userId_:userSlug" component={ProfileUser}/>
                    <Route path="/mon-profil/parametres" component={RequireAuth(Settings)}/>
                    <Route path="/mon-profil" component={RequireAuth(Profile)}/>
                    <Route path="/blog-sexe-amateur/:page([0-9]+)?" exact component={Articles}/>
                    <Route path={ROUTES_CONFIG.PROFILE.USER.MAIN} component={Profile}/>
                    <Route path="/tag-moderations" component={RequireAuth(TagModerations)}/>

                    {/*PROFILE*/}
                    {/*<Route path="/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug" exact
                           component={ProfileUser}/>
                    <Route
                        path="/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug/rencontre"
                        exact component={ProfileUserDating}/>
                    <Route
                        path="/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug/amis/:page([0-9]+)?"
                        exact component={ProfileUserFriends}/>


                    <Route path="/blog-sexe-amateur/:userSlug/:articleSlug([A-Za-z0-9_-]+)_:articleId?" exact
                           component={ProfileUserArticle}/>
                    <Route path="/blog-sexe-amateur/:userSlug/:page([0-9]+)?" exact component={ProfileUserArticles}/>
                    <Route path="/blog-sexe-amateur/:userSlug/:blogSlug([A-Za-z0-9_-]+)/:page([0-9]+)?" exact
                           component={ProfileUserArticles}/>

                    <Route path="/exhibition-sexe/:userSlug/:page([0-9]+)?" exact component={ProfileUserAlbums}/>
                    <Route path="/exhibition-sexe/:userSlug/:albumSlug([A-Za-z0-9_-]+)_:albumId/:page([0-9]+)?" exact
                           component={ProfileUserAlbum}/>*/}
                    {/*!PROFILE*/}



                    {/*<Route path="/blog-sexe-amateur/:slug([A-Za-z0-9_-]+)_:id" exact component={Article}/>*/}
                    <Route path="/forum-sex" exact component={Forums}/>
                    <Route path="/forum-sex/derniers-messages" exact component={ForumLastTopics}/>
                    <Route
                        path="/forum-sex/:slugParent([A-Za-z0-9_-]+)?/:slug([A-Za-z0-9_-]+)/:topicSlug([A-Za-z0-9_-]+)_:topicId/:page([0-9]+)?"
                        exact component={ForumsTopic}/>

                    <Route path="/forum-sex/:slug([A-Za-z0-9_-]+)/:page([0-9]+)?" exact component={ForumsSubOrTopics}/>
                    <Route path="/forum-sex/:slugParent([A-Za-z0-9_-]+)?/:slug([A-Za-z0-9_-]+)/:page([0-9]+)?" exact
                           component={ForumsSubOrTopics}/>

                    {/*<Route path="/topic/:id-:slug/:page([0-9]+)?" component={ForumsTopic}/>*/}
                    <Route path="/top-users/:page([0-9]+)?" component={TopUsers}/>

                    <Route path="/photos-sexe/:page([0-9]+)?" component={Photo}/>
                    <Route path="/videos-sexe/:page([0-9]+)?" component={Video}/>

                    <Route path="/(xxx-photos|xxx-videos)/:slug([A-Za-z0-9_-]*)_:mediaId([0-9a-fA-F]{24})" component={MediaViewer}/>

                    <Route path="/histoires-de-sexe/regles" component={StoryTerms}/>
                    <Route path="/histoires-de-sexe/:page([0-9]+)?" component={Stories}/>

                    <Route
                        path="/:typeTag(photo-sexe|video-sexe|histoire-de-sexe|article-sexe)/:tagSlug([A-Za-z0-9_-]+)/:page([0-9]+)?"
                        exact component={tagSearch}/>
                    <Route
                        path="/:typeTag(photo-sexe|video-sexe|histoire-de-sexe|article-sexe)/:tagSlug([A-Za-z0-9_-]+)/:userSlug([A-Za-z0-9_-]+)/:page([0-9]+)?"
                        exact component={tagSearch}/>
                    <Route
                        path="/:typeTag(photo-sexe|video-sexe|histoire-de-sexe|article-sexe)/:tagSlug([A-Za-z0-9_-]+)/:userSlug([A-Za-z0-9_-]+)/:all(all)/:page([0-9]+)?"
                        exact component={tagSearch}/>

                    <Route path="/fil-actualite" component={RequireAuth(FilActu)}/>


                    <Route path="/notifications" component={RequireAuth(Notifications)}/>

                    {/*<Route path="/messenger/:roomId?" component={RequireAuth(Messenger)}/>*/}
                    <Route path="/messenger" component={RequireAuth(Messenger)}/>
                    <Route exact path="/rencontre/:page([0-9]+)?" component={Meet}/>
                    <Route path="/moderation-commentaire/:page([0-9]+)?" component={RequireAuth(Moderation)}/>

                    <Route path="/recherche/:searchUsername/:page([0-9]+)?" component={Search}/>


                    {/*<Route path="/pc-moderateur" component={RequireAuth(ModeratorPC)} />*/}
                    {/*<Route path="/moderation" component={ContentModeration} />*/}

                    <Route path="/charte" component={Charter}/>
                    <Route path="/cgus" component={Terms}/>
                    <Route path="/historique" component={HistoryPage}/>
                    <Route path="/contact" component={Contact}/>
                    {/*<Route path="/suppression-de-compte" component={RequireAuth(DeleteAccount)}/>*/}
                    <Route path="/supprimer-mon-compte" component={RequireAuth(ConfirmSuppressionAccount)}/>

                    <Route path="/privacypolicy" component={PrivacyPolicy}/>
                    <Route path="/mediaviewer/:mediaId_:slug([A-Za-z0-9_-]+)" component={MediaViewerPage}/>
                    <Route path="/pc-moderateur" component={PcReporting}/>


                    <Route exact path="/controle-parental" component={ParentalControl} />
                    <Route exact path="/confiance-et-securite" component={TrustSecurity} />
                    <Route exact path="/page-introuvable" component={ErrorNotFound} status={404}/>

                    {/*REDIRECTION*/}
                    {/*<Redirect from="/videos/:tagSlug([A-Za-z0-9_-]+)" to="/video-sexe/:tagSlug([A-Za-z0-9_-]+)"/>*/}
                    <RedirectVideoCategories from="/videos/:tagSlug([A-Za-z0-9_-]+)/page/:page([0-9]+)" />
                    <RedirectVideoCategories from="/videos/:tagSlug([A-Za-z0-9_-]+)" />
                    {/*<RedirectWithStatus status={301}  from="/videos/:params([A-Za-z0-9_-]+)" to="/video-sexe"  />*/}
                    <RedirectWithStatus status={301} from="/videos" to="/videos-sexe"/>
                    <RedirectWithStatus status={301} from="/photos/(hier|semaine|mois|mois-dernier)?"
                                        to="/photos-sexe"/>
                    <RedirectWithStatus status={301} from="/blogs/(hier|semaine|mois|mois-dernier)?"
                                        to="/blog-sexe-amateur"/>


                    {/*<RedirectWithStatus status={301} from="/histoires/:params([A-Za-z0-9_-]+)/page/:page([0-9]+)?" to="/histoires-de-sexe/:params" isParams={true} isPagination={false}/>*/}
                    <Redirect from="/histoires/:tagSlug/page/:page([0-9]+)" to="/histoire-de-sexe/:tagSlug" state={{ status: 301 }} />
                    <Redirect from="/histoires/:tagSlug" to="/histoire-de-sexe/:tagSlug" state={{ status: 301 }} />
                    <RedirectWithStatus status={301} from="/histoires" to="/histoires-de-sexe"/>
                    {/*<RedirectWithStatus status={301} from="/videos" to="/videos-sexe" />*/}
                    {/*<RedirectWithStatus status={301} from="/videos" to="/videos-sexe" />*/}


                    {/*<Route path="/f/:categorySlug/:page([0-9]+)" component={FacettesUri} />*/}
                    <Route path="/f/:page([0-9]+)?" exact component={FacettesAncre}/>
                    <Route path="/f/*" component={interceptFacetteUri} />


                    <Route component={ErrorNotFound} status={404}/>
                </Switch>
            </Main>
        </Switch>
    )
}

export default MainRouter;
